import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { MdOutlineSaveAs } from "react-icons/md";
import { ICON_SIZES } from "src/constants/icons";
import useMobile from "src/hooks/useMobile";

interface IChangesPendingToSave {
  show: boolean;
}

const ChangesPendingToSave: React.FC<IChangesPendingToSave> = ({ show }) => {
  const { t } = useTranslation();
  const { isMobile } = useMobile();

  if (!show) return null;

  return (
    <div
      className={clsx([
        "flex",
        "flex-row",
        "items-center",
        "gap-1",
        "flex-shrink-0",
      ])}
      title={t("common:tooltips.unsaved_changes")}
    >
      <MdOutlineSaveAs
        size={isMobile ? ICON_SIZES.SM : ICON_SIZES.SM}
        className={clsx(["text-red-500", "dark:text-purple-400", "shrink-0"])}
      />
      <span
        className={clsx([
          "!text-xs",
          "text-red-500",
          "dark:text-white",
          "shrink-0",
        ])}
      >
        {t("misc:strings.edited")}
      </span>
    </div>
  );
};

export default ChangesPendingToSave;
